import {css, styled} from 'styled-components'
import {ModalOverlay, Modal} from '@components/ui/modal-atoms/ModalAtoms.tsx'

// Raised above the conversations modal this dialog is opened from
export const StyledDeleteMessageModalOverlay = styled(ModalOverlay)(
    ({theme: {zIndex}}) => css`
        z-index: ${zIndex.modal + 1};
    `
)

export const StyledDeleteMessageModal = styled(Modal)(
    ({theme: {zIndex}}) => css`
        z-index: ${zIndex.modal + 2};
    `
)
